import { createAsyncThunk } from '@reduxjs/toolkit';

import makeApiCall from './apiService';

export const createApiAction = <T, P = void, D = any>(
  type: string,
  url: string,
  method: 'delete' | 'get' | 'post' | 'put' | 'logIn' = 'get',
  endpointGenerator?: (params?: P, data?: D) => string
) =>
  createAsyncThunk<T, { data?: D; params?: P }, { rejectValue: string }>(
    type,
    async ({ data, params }, { rejectWithValue }) => {
      try {
        const endpoint = endpointGenerator
          ? endpointGenerator(params, data)
          : url;
        const response = await makeApiCall<T>(endpoint, method, data);
        return response;
      } catch (error) {
        return rejectWithValue(`Failed to ${method} data from ${url}`);
      }
    }
  );
